<script setup lang="ts">
import type { TutorBillingRow } from '../model/interfaces'

import { faEraser, faPen } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useTutorBillingRowActions } from '../model/tutor-billing-row-actions.hook'

defineOptions({
  name: 'TutorBillingRowActions',
})

const props = defineProps<{
  row: TutorBillingRow
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  setToggle,
  setOpenEdit,
  setOpenErase,
} = useTutorBillingRowActions({
  row: computed(() => props.row),
})
</script>

<template>
  <div
    ref="containerRef"
    class="tutor-billing-row-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for billing #${row.id}`"
      @click="setToggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="tutor-billing-row-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit billing info"
          color="blue"
          :prepend-icon="faPen"
          @click="setOpenEdit"
        />
        <AppDropdownItem
          text="Erase billing info"
          color="red"
          :prepend-icon="faEraser"
          @click="setOpenErase"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TutorBillingRowActions.scss" />
